// Toggles `data-app-idle="true"` on <html> when the tab is hidden so CSS
// animations can pause. Runs once on module load. Uses `pagehide` / `pageshow`
// in addition to `visibilitychange` to catch bfcache restores on Safari/iOS.

if (typeof document !== 'undefined') {
  const root = document.documentElement

  const setIdle = (idle: boolean) => {
    if (idle) root.setAttribute('data-app-idle', 'true')
    else root.removeAttribute('data-app-idle')
  }

  const sync = () => setIdle(document.visibilityState === 'hidden')

  sync()
  document.addEventListener('visibilitychange', sync)
  window.addEventListener('pagehide', () => setIdle(true))
  window.addEventListener('pageshow', () => setIdle(false))
}

export {}
